import React, {useEffect, useState} from 'react'
import ArrowDown from '../../../assets/icons/ArrowDown'
import { NavLink } from 'react-router-dom'
import NavLinkCont from '../NavLinkCont';
import { useDispatch, useSelector } from 'react-redux';
import { getCategoryByNav, getServicesByNav } from '../../../services/actions/MainAction';

function HeaderLink() {
  const dispatch = useDispatch();
  const lang_id = useSelector(state=> state.Data.lang_id);
  const categoryNav = useSelector(state=> state.Data.categoryNav);
  const navServices = useSelector(state=> state.Data.navServices);
  const langPrefix = useSelector(state=> state.Data.langPrefix);
  
  useEffect(()=>{
    dispatch(getCategoryByNav(lang_id))
    dispatch(getServicesByNav(lang_id))
  },[lang_id])
  const contentData = useSelector(state => state.Data.contentData);
  const filterItem = (products, path=`/${langPrefix}product`)=>{
    let arr = [];
    for(const data of products){
      arr.push({
        title: data?.translate?.title,
        path: `${path}/${data?.path}`,
        options:[]
      })
    }
    return arr;
  }

  const filterCategory = (item) => {
    // console.log(item)
    let arr = [];
    for(const data of item?.categories){
      arr.push({
        title: data?.translate?.title,
        path: `/${langPrefix}products?category_id=${data?.id}`,
        options: filterItem(data?.products)
      })
    }
    arr.push(
      ...filterItem(item?.products)
    );
    return arr;
  }
  return (
    <nav className='flex items-center h-full '>
      <ul className='flex items-center gap-[45px] h-[100px] max-[1400px]:gap-[20px] max-[1240px]:gap-[12px]'>
        <NavLinkCont path={`/${langPrefix}about`} title={contentData?.nav_1} />
        <NavLinkCont path={`/${langPrefix}services`} title={contentData?.nav_2} options={filterItem(navServices,  `/${langPrefix}service`)} />
        <NavLinkCont path={`/${langPrefix}products`} title={contentData?.nav_3} options={filterCategory(categoryNav)} />
        {/* <NavLinkCont path={''} options={[{title: contentData?.nav_7, path:`/${langPrefix}license`, options:[]},{title: contentData?.nav_6, path:`/${langPrefix}awards`, options:[]}]} title={contentData?.nav_4} /> */}
        <NavLinkCont path={`/${langPrefix}contact`} title={contentData?.nav_5} />
      </ul>
    </nav>
  )
}

export default HeaderLink
